module.exports = __webpack_public_path__ + "static/assets/e3f169a55f5dc789aee29c56a46f9078.svg";